import Api from './../api'
import DataLayer from './../data-layer/index'

DataLayer.$extend('models', {
    dispatch(modelsInput) {
        return Api.models.dispatch({ models: modelsInput, depth: 2 })
    },
})
